<div
  class="rv-sortable-handle tw-rounded-sm"
  [class.dragging]="isDragging"
  tabindex="0"
  role="button"
  [attr.data-sortable-index]="sortableIndex"
  [attr.data-item-id]="item?.rvSortableId"
  [attr.aria-label]="
    'Move ' +
    displayName +
    '. Press space to select, then use arrow keys to reorder.'
  "
  [attr.aria-describedby]="ariaDescribedby"
  (keydown)="onKeydown($event)"
  (blur)="onBlur()"
  (mousedown)="onMousedown()"
  (mouseup)="onMouseup()"
  (mouseleave)="onMouseleave()"
>
  <mat-icon aria-hidden="true" svgIcon="drag-stroke"></mat-icon>
</div>
